<template>
  <div class="clearfix"  v-loading.fullscreen.lock="loading">
    <div class="right-content clearfix busWinessRight">
      <div class="file-entry">
        <el-card class="complaint-card" style="margin-top:23px">
          <div slot="header" class="clearfix">
            <span>投诉人信息</span>
          </div>
          <complainantInfo :ruleForm="oneData"></complainantInfo>
        </el-card>
        <el-card class="complaint-card">
          <div slot="header" class="clearfix">
            <span>投诉项目信息</span>
          </div>
          <complainantProjectInfo :ruleForm="oneData"></complainantProjectInfo>
        </el-card>
        <el-card class="complaint-card">
          <div slot="header" class="clearfix">
            <span>投诉内容</span>
          </div>
          <complainantCont :ruleForm="oneData"></complainantCont>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
import complainantInfo from './components/complainant_info';
import complainantProjectInfo from './components/complainant_project_info';
import complainantCont from './components/complaint_cont';
// import {tabsCloseCurrentHandle} from '@/utils/routeTab';

export default {
  name: "onlineDetail",
  components: {
    complainantInfo,
    complainantProjectInfo,
    complainantCont,
  },
  props:['oneData'],
  data() {
    return {
      loading: false,
    }
  },
  mounted(){
    console.log(this.oneData)
  },
  methods: {
    back() { // 返回
      tabsCloseCurrentHandle();
      this.$router.push({
        name: 'online_complaints_list',
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.main_center {
  .base_info {
    li {
      .name {
        font-size: 14px;
        display: inline-block;
        color: rgba(0, 0, 0, 0.65);
        text-align: right;
        width: 130px;
        line-height: 26px;
      }

      .cont {
        font-size: 14px;
        display: inline-block;
        color: rgba(0, 0, 0, 0.85);
        line-height: 26px;
      }
    }
  }

  .el-collapse {
    border: 0;

    .el-collapse-item {
      margin: 0 0 10px 0;
    }

    /deep/ .el-collapse-item__content {
      padding-bottom: 0;
    }

    /deep/ .el-collapse-item__header {
      padding: 0 12px;
      font-size: 16px;
      color: #000000;
    }

    /deep/ .el-collapse-item__header.is-active {
      border-bottom: 1px solid #1890FF;
      color: #1890FF
    }

    /deep/ .el-collapse-item__wrap {
      border: 0;
      padding: 12px 24px;
    }


  }
}
</style>
